// extracted by mini-css-extract-plugin
export default {"container":"card-cloud_container__8fI+6","content":"card-cloud_content__9IVb4"};